export const bannerTypes = {
  HORIZONTAL_BANNER: 'horizontal',
  VERTICAL_BANNER: 'vertical',
} as const

export type bannerType = typeof bannerTypes[keyof typeof bannerTypes]
export type bannerTypeArray = bannerType[]

export const gameAliasToIdMap = {
  EMPIRE: 12,
  BIGFARM: 15,
} as const

export type gameId = typeof gameAliasToIdMap
export type gameAlias = gameId[keyof gameId]

export const adUnitAliasToPath = {
  EMPIRE_VERTICAL: '/21812119314/Banner_Empire_160x600',
  EMPIRE_HORIZONTAL: '/21812119314/Banner_Empire_728x90',
  BIGFARM_VERTICAL: '/21812119314/Banner_BigFarm_160x600',
  BIGFARM_HORIZONTAL: '/21812119314/Banner_BigFarm_728x90',
} as const

export type adUnitId = typeof adUnitAliasToPath
export type adUnitAlias = adUnitId[keyof adUnitId]

export const CxfEvents = {
  Token: 'cxf.token',
  Login: 'cxf.login',
  Signup: 'cxf.signup',
  GameEventUpdate: 'cxf.gameEvent.update',
  GameEventAdd: 'cxf.gameEvent.add',
  GameEventRemove: 'cxf.gameEvent.remove',
  XpChanged: 'cxf.xp.changed',
  LevelChanged: 'cxf.level.changed',
  LegendLevelChanged: 'cxf.legendLevel.changed',
  Push: 'cxf.push',
  OpenIGS: 'cxf.igs.open',
  CloseIGS: 'cxf.dialog.close',
  AdBannerStatus: 'cxf.adBanner.status',
  JoinTempServer: 'cxf.join.temp.server',
  Subscription: 'cxf.subscription',
}

export const BigFarm = {
  UPDATE_PAY: 'PAYMENT_DATA',
}

export const Empire = {
  UPDATE_PAY: 'upi',
}

export const HTML_IDS = {
  AD_PLACEHOLDER: 'ad-placeholder',
  AD_CONTAINER: 'ad-container',
}

export const AdBannerEvent = {
  LOGIN: 'login',
  UPDATE_PAY: 'updatePay',
} as const

type typeAdBannerEvent = typeof AdBannerEvent
export type AllowedBannerEvents = typeAdBannerEvent[keyof typeAdBannerEvent]

export const defaultGameMinWidth = 800
export const defaultGameMinHeight = 600

export const GAME_TARGET_ID = 'game'

export const GOOGLE_PUBLISHER_TAG = 'https://securepubads.g.doubleclick.net/tag/js/gpt.js'

export const IGS_ENTRY_TAB_ID = 'dailybundles'
export const IGS_AD_BLOCK_SOURCE_ID = 'adBlockPopupShopButton'

// Prebid.js constants
export const BIDDERS_TIMEOUT = 1000
export const FAILSAFE_TIMEOUT = 1050

export const APS_PUB_ID = 'fb17ae44-d7a8-4c56-8a84-156b9387a3da'

export const IX_SITE_ID = {
  [adUnitAliasToPath.EMPIRE_HORIZONTAL]: '923928',
  [adUnitAliasToPath.EMPIRE_VERTICAL]: '923928',
  [adUnitAliasToPath.BIGFARM_HORIZONTAL]: '923929',
  [adUnitAliasToPath.BIGFARM_VERTICAL]: '923929',
}

export const PUBMATIC_PUBLISHER_ID = '162973'

export const RUBICON_SITE_ID = '376420'
export const RUBICON_ACCOUNT_ID = '23558'
export const RUBICON_ZONE_ID = {
  [adUnitAliasToPath.EMPIRE_HORIZONTAL]: '2764324',
  [adUnitAliasToPath.EMPIRE_VERTICAL]: '2764324',
  [adUnitAliasToPath.BIGFARM_HORIZONTAL]: '2764328',
  [adUnitAliasToPath.BIGFARM_VERTICAL]: '2764328',
}

export const UNDERDOG_SITE_ID = {
  [adUnitAliasToPath.EMPIRE_HORIZONTAL]: '19027', // UDM_PB_empire.goodgamestudios.com
  [adUnitAliasToPath.EMPIRE_VERTICAL]: '19027', // UDM_PB_empire.goodgamestudios.com
  [adUnitAliasToPath.BIGFARM_HORIZONTAL]: '19028', // UDM_PB_bigfarm.goodgamestudios.com
  [adUnitAliasToPath.BIGFARM_VERTICAL]: '19028', // UDM_PB_bigfarm.goodgamestudios.com
}

export const OPENX_DOMAIN = 'goodgamestudios-d.openx.net'
export const OPENX_UNIT_ID = {
  [adUnitAliasToPath.EMPIRE_HORIZONTAL]: '559469885',
  [adUnitAliasToPath.EMPIRE_VERTICAL]: '559469886',
  [adUnitAliasToPath.BIGFARM_HORIZONTAL]: '559469887',
  [adUnitAliasToPath.BIGFARM_VERTICAL]: '559469888',
}

export const MEDIANET_CID = '8CUW5Q486'
export const MEDIANET_CRID = {
  [adUnitAliasToPath.EMPIRE_HORIZONTAL]: '712245820',
  [adUnitAliasToPath.EMPIRE_VERTICAL]: '664756262',
  [adUnitAliasToPath.BIGFARM_HORIZONTAL]: '176932359',
  [adUnitAliasToPath.BIGFARM_VERTICAL]: '542226828',
}
